import { render, staticRenderFns } from "./ReportsClientsSectionView.vue?vue&type=template&id=fc2a4f84"
import script from "./ReportsClientsSectionView.vue?vue&type=script&lang=js"
export * from "./ReportsClientsSectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports